import styled from 'styled-components';

import { BorderRadius, Colors, Spacing } from '@doordash/design-language';
import { button } from 'constants/style';
import { Button } from 'top-component-library';

export const Container = styled.div`
  max-width: 100%;
  width: 100%;
`;

export const Tile = styled.div`
  background-color: ${Colors.SystemWhite};
  border-radius: ${BorderRadius.XLarge}px;
  text-align: center;
  padding: ${Spacing.XLarge}px ${Spacing.Small}px ${Spacing.XLarge}px ${Spacing.Small}px;
  box-shadow: ${Spacing.None} ${Spacing.XxxSmall}px ${Spacing.Small}px rgba(0, 0, 0, 0.2);
`;

export const TileTitle = styled(Tile)`
  padding: ${Spacing.XLarge}px ${Spacing.Large}px ${Spacing.XLarge}px ${Spacing.Large}px;
  margin-bottom: ${Spacing.Large}px;
`;

export const StyledPrimaryButton = styled(Button)`
  align-items: center;
  background-color: ${Colors.SystemWhite};
  border-radius: ${Spacing.XxSmall}px;
  display: flex;
  height: fit-content;
  width: 100%;
  justify-content: space-between;
  padding: 11px ${Spacing.Small}px;
  margin-bottom: ${Spacing.Small}px;
  box-shadow: ${Spacing.None} ${Spacing.XxxxSmall}px ${Spacing.XxSmall}px ${Spacing.None} rgba(0, 0, 0, 0.2);
  color: ${Colors.TextPrimary};
  font-weight: 700;

  span {
    padding: 2px 0px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    overflow: hidden;
    width: auto;
    white-space: break-spaces;
    text-align: start;
  }
`;

export const StyledSecondaryButton = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--color-dd-system-white);
  border-style: solid;
  border-radius: ${Spacing.XxSmall}px;
  border-width: 1px;
  border-color: ${Colors.ButtonTertiaryBackground};
  color: ${Colors.TextPrimary};
  font-weight: 700;
  height: ${button.regular}px;
  padding: 1rem;
  margin-top: ${Spacing.Small}px;
  width: 100%;

  &.ant-btn-default {
    &:hover {
      border-color: #d9d9d9;
      color: var(--color-neutral__icon);
    }
  }
`;

export const Logo = styled.img`
  width: var(--landing-page-logo__width, 100px);
  height: auto;
  object-fit: cover;
  position: relative;
  padding-bottom: ${Spacing.Large}px;
`;
